import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import cn from 'classnames'
import themeVars from 'ui_theme/site/globals/site.variables'

import Attachments from 'components/Attachments'
import MentionSelector from 'components/MentionSelector'
import NoteComposer from 'components/App/DesktopView/shared/Composer/Note'
import NavBar from 'components/App/DesktopView/shared/Composer/Email/Header/NavBar'
import { Flex } from 'shared/ui'
import withFocusing from '../withFocusing'

const MentionWrapper = styled('div')`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  margin-left: ${props => props.theme.spacing['12']};
  margin-right: ${props => props.theme.spacing['12']};
`

function Commenting(props) {
  const {
    className,
    doDeleteDraft,
    focused,
    isDraftSendable,
    isOpen,
    noteDraft,
    showMentionSelector,
    ticketId,
    updateAndSendDraft,
  } = props

  return (
    <React.Fragment>
      <MentionWrapper className="mention-wrapper" key="mentionwrapper">
        {showMentionSelector && <MentionSelector />}
      </MentionWrapper>
      <Flex className={cn(className, { focused })} key="form">
        <NavBar commenting ticketId={ticketId} />
        <div css={{ marginTop: themeVars.small }}>
          <NoteComposer
            config={{
              autoresize_bottom_margin: 0,
              autoresize_min_height: 60,
              autoresize_on_init: true,
            }}
            draft={noteDraft}
            editorBottom={<Attachments forDraft forNote key="attachments" />}
            isDraftSendable={isDraftSendable}
            isOpen={isOpen}
            key="noteform"
            onDeleteDraft={doDeleteDraft}
            placeholderHeight={73}
            updateAndSendDraft={updateAndSendDraft}
            ticketId={ticketId}
          />
        </div>
      </Flex>
    </React.Fragment>
  )
}

Commenting.propTypes = {
  doDeleteDraft: PropTypes.func.isRequired,
  isDraftSendable: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  ticketId: PropTypes.string.isRequired,
  noteDraft: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  updateAndSendDraft: PropTypes.func.isRequired,
}

export default styled(withFocusing(Commenting))`
  background-color: ${props => props.theme.color.secondary.warning};
  border-radius: 4px;
  border: 1px solid ${props => props.theme.color.monochrome.medium};
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  padding: ${props =>
    `${props.theme.spacing['4']} ${props.theme.spacing['10']}`};
  z-index: 100;

  .NoteComposer {
    max-height: 40vh;
  }

  .mention-wrapper {
    position: relative;
  }

  &.focused {
    border-color: ${props => props.theme.color.secondary.warning};
  }
`
